import {Budget, BudgetRestControllerApiFactory, DeliveryStatsDto} from "arteco-api-client-ts";
import React, {useEffect, useState} from "react";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {Box, TableCell, Typography} from "@mui/material";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import HourglassBottomRoundedIcon from "@mui/icons-material/HourglassBottomRounded";
import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import {dateToString} from "../../../../components/utils/dates";
import {SoftChip, StatGrid, StatTile} from "../../../../components/kit";


export const BudgetListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(BudgetRestControllerApiFactory);
	// Terminar a tiempo con conformidad, 12 meses (#13749). «n de m», no un %: son pocos al año.
	const [deliveries, setDeliveries] = useState<DeliveryStatsDto>();
	useEffect(() => {
		ctrl.deliveryStatsBudget().then(resp => setDeliveries(resp.data));
	}, []);

	const listConfig: AppListConfig<Budget> = {
		title: "Presupuestos",
		onClick: "/app/admin/billing/budget",
		headers: [
			{title: "Estado", width: "10%"},
			{title: "Cliente", width: "13%"},
			{title: "Presupuesto", width: "27%"},
			{title: "Responsable", width: "14%"},
			{title: "Unidad", width: "10%"},
			{title: "Desde – hasta", width: "13%"},
			{title: "Aceptación", width: "7%"},
			{title: "Horas", align: "right", width: "6%"},
		],
		decorator: (bean: Budget) => (
			<>
				<TableCell>
					{bean.completed
						? <SoftChip label="Completado" tone="neutral"/>
						: <SoftChip label="En curso" tone="info"/>}
				</TableCell>
				<TableCell sx={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
					<Typography variant="body2" noWrap>{bean.customer.shortName || "—"}</Typography>
					<Typography variant="caption" color="text.secondary">{bean.customer.id}</Typography>
				</TableCell>
				<TableCell sx={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}} title={bean.title}>
					<Typography variant="body2" fontWeight={600} noWrap>{bean.title}</Typography>
					<Typography variant="caption" color="text.secondary">{bean.id}</Typography>
				</TableCell>
				<TableCell sx={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
					{bean.owner?.surnamesAndName}
				</TableCell>
				<TableCell sx={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
					{bean.organizationUnit?.name}
				</TableCell>
				<TableCell sx={{whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums"}}>
					{bean.startDate ? dateToString(bean.startDate) : "…"} – {bean.endDate ? dateToString(bean.endDate) : "…"}
				</TableCell>
				<TableCell>
					{(bean.customerAcceptance || "").length > 0
						? <SoftChip label="Sí" tone="success"/>
						: <SoftChip label="Falta" tone="error"/>}
				</TableCell>
				<TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
					{bean.totalHours ? bean.totalHours.toLocaleString("es-ES", {maximumFractionDigits: 1}) : "—"}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			return ctrl.pageBudget(
				currentPage,
				size,
				undefined,
				term,
				showDismissed
			);
		}
	};

	return (
		<>
			{deliveries && (
				<Box sx={{mb: 1}}>
					<StatGrid>
						<StatTile icon={<EventAvailableRoundedIcon fontSize="small"/>} tone="success"
								  value={`${deliveries.onTimeAndAccepted} de ${deliveries.closed}`}
								  label="Proyectos cerrados en 12 meses entregados a tiempo y con conformidad"/>
						{deliveries.averageDelayDays != null && (
							<StatTile icon={<HourglassBottomRoundedIcon fontSize="small"/>}
									  tone={deliveries.averageDelayDays > 0 ? "warning" : "neutral"}
									  value={`${Math.round(deliveries.averageDelayDays)} días`} label="Retraso medio"/>
						)}
						{(deliveries.withoutCommittedDate || 0) > 0 && (
							<StatTile icon={<EventBusyRoundedIcon fontSize="small"/>} tone="warning"
									  value={deliveries.withoutCommittedDate} label="Sin fecha comprometida"/>
						)}
					</StatGrid>
				</Box>
			)}
			<AppList config={listConfig}/>
		</>
	);
};
